// Packages
import { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

// material Ui
import Grid from "@material-ui/core/Grid";
import {
  getFromLocalStorage,
  removeFromLocalStorage,
} from "../../utils/webStorage";

//Services
import userService from "../../services/user.service";

// Styles
import "../superAdmin/superAdmin.css";
import SchoolAdminDashboard from "./schoolAdminDashboard";
import HomeTrending from "./homepage/Trending";
import ActivityHistory from "./homepage/ActivityHistory";
import { CircularProgress } from "@material-ui/core";
import { openSuccessPopup } from "../../Redux/Actions/PopupActions";
import { connect } from "react-redux";
import { fullPageLoading } from "../../Redux/Actions/LoadingActions";

class DashboardData extends Component {
  constructor() {
    super();
    this.state = {
      activeAthletesCount: null,
      activeCoachesCount: null,
      activeGroupCount: null,
      activeTeamCount: null,
      activeEventCount: null,
      inactiveAthletesCount: null,
      inactiveCoachesCount: null,
      getAllSchoolGraphData: [],
      getAllSchoolGraphData1: [],
      year: "2021",
      startDate: new Date(),
      endDate: new Date(),
      fromDate: "",
      toDate: "",
      startDate1: new Date(),
      endDate1: new Date(),
      fromDate1: "",
      toDate1: "",
      submitting: false,
      CoachGraphData: [],
      AthleteGraphData: [],
      activityResponses: [],
      activityFlag: true,
      isBtnActive: false,
      hours: "",
      successPopUp: false,
    };
  }

  componentDidMount() {
    const feed = document.getElementById("Dashboard");
    if (feed) {
      feed.classList.add("btnActive");
    }
    const schoolId = getFromLocalStorage("schoolId");
    const schoolName = getFromLocalStorage("schoolName");
    this.setState({ schoolName });
    removeFromLocalStorage("streamUrlKinesis");
    removeFromLocalStorage("streamUrlKinesis1");
    this.getAllAdminData(schoolId);
    const date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth();
    const startDate = new Date(y, m, 1);
    const startDate1 = new Date(y, m, 1);
    this.setState({ schoolId, startDate, startDate1 });
  }

  getAllAdminData(schoolId) {
    const { fullPageLoading } = this.props;
    fullPageLoading(true);
    this.getStorageDetails(schoolId);
    userService
      .adminSchoolData(schoolId)
      .then((res) => {
        const data = res.data.data;
        const activeAthletesCount = data.athletesCount;
        const activeCoachesCount = data.coachesCount;
        const activeGroupCount = data.groupCount;
        const activeTeamCount = data.teamCount;
        const activeEventCount = data.eventCount;
        const inactiveAthletesCount = data.inactiveAthletesCount;
        const inactiveCoachesCount = data.inactiveCoachesCount;
        this.setState({
          activeAthletesCount,
          activeCoachesCount,
          activeGroupCount,
          activeTeamCount,
          inactiveAthletesCount,
          inactiveCoachesCount,
          activeEventCount,
          submitting: false,
        });
        fullPageLoading(false);
      })
      .catch(() => {
        fullPageLoading(false);
      });
  }

  getStorageDetails = (schoolId) => {
    userService
      .getAllSportsHoursDetails(schoolId)
      .then((res) => {
        const { usedHours } = res.data.data;
        this.setState({ hours: usedHours.toFixed(2) });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  toggleSuccessDialog = () => {
    const { successPopUp } = this.state;
    this.setState({ successPopUp: !successPopUp });
  };

  handleWorkInProgress = () => {
    const { setSuccessPopupInformation } = this.props;
    setSuccessPopupInformation({
      successPopUp: {
        message: "Work In Progress",
        open: true,
      },
    });
  };

  render() {
    const {
      activeCoachesCount,
      activeGroupCount,
      submitting,
      activeEventCount,
      activityResponses,
      hours,
      successPopUp,
    } = this.state;
    const { isDrawerOpen } = this.props;
    return (
      <div>
        <div className="clear10"></div>
        <div className="dynamic-height">
          <div>
            <div
              className={
                isDrawerOpen
                  ? "content-layout pd-10-20"
                  : "toggle-content-layout pd-10-20"
              }
            >
              <SchoolAdminDashboard />

              <div>
                <h4 className="fs-24 bold mob-hd mg-bottom-10">Homepage</h4>
              </div>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={6} lg={3}>
                  <div className="main-card-box-2 brd-grey">
                    <div className=" white-card">
                      <label className="semi-bold fs-20 mobofs20 ipadFont">
                        SPORTS
                      </label>
                      <hr className="hr-line"></hr>
                      <div className="d-flex-space-between">
                        <div>
                          <div className=" semi-bold mobofs-60 totalNumber">
                            1
                          </div>
                          <p className=" semi-bold coachCount">Total sports</p>
                        </div>
                      </div>
                      <div className="clear30"></div>
                      <Link to="/sports">
                        <div className="fs-18 link-blue semi-bold mobofs20">
                          <u>See Details</u>
                        </div>
                      </Link>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <div className="main-card-box-2 brd-grey">
                    <div className=" white-card">
                      <label className="semi-bold fs-20 mobofs20 ipadFont">
                        HOURS
                      </label>
                      <hr className="hr-line"></hr>
                      <div className="d-flex-space-between">
                        <div>
                          <div className="totalNumber semi-bold mobofs-60">
                            {hours ? hours : 0}
                          </div>
                          <p className="semi-bold coachCount">
                            Total Hours Used
                          </p>
                        </div>
                      </div>
                      <div className="clear30"></div>
                      <Link to="/hours">
                        <div className="fs-18 link-blue semi-bold mobofs20">
                          <u>See Details</u>
                        </div>
                      </Link>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <div className="main-card-box-2 brd-grey">
                    <div className="white-card">
                      <label className="semi-bold fs-20 mobofs20 ipadFont">
                        BILLING
                      </label>
                      <hr className="hr-line"></hr>
                      <div className="d-flex-space-between">
                        <div>
                          <div className="totalNumber semi-bold mobofs-60">
                            0
                          </div>
                          <p className="semi-bold coachCount">Invoice due</p>
                        </div>
                      </div>
                      <div className="clear30"></div>
                      <div className="fs-18 link-blue semi-bold mobofs20 cp">
                        <u onClick={() => this.handleWorkInProgress()}>
                          See Details
                        </u>
                      </div>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} sm={6} lg={3}>
                  <div className="main-card-box-2 brd-grey">
                    <div className=" white-card">
                      <label className="semi-bold fs-20 mobofs20 ipadFont">
                        RENEWALS
                      </label>
                      <hr className="hr-line"></hr>
                      <div className="d-flex-space-between">
                        <div>
                          <div className="semi-bold totalNumber">
                            <span>0</span>
                          </div>
                          <p className="semi-bold  coachCount">
                            Upcoming Renewals
                          </p>
                        </div>
                      </div>
                      <div className="clear30"></div>
                      <div className="fs-18 link-blue semi-bold mobofs20 cp">
                        <u
                          onClick={() => {
                            this.handleWorkInProgress();
                          }}
                        >
                          See Details
                        </u>
                      </div>
                    </div>
                  </div>
                </Grid>
              </Grid>
              <div className="clear30"></div>

              <div className="row">
                <div className="col-lg-6">
                  <ActivityHistory activityResponses={activityResponses} />
                </div>

                <div className="col-lg-6">
                  <HomeTrending />
                </div>
              </div>
            </div>
          </div>

          {/* {submitting && (
            <CircularProgress className="circle-mark" color="secondary" />
          )} */}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setSuccessPopupInformation: (obj) => openSuccessPopup(dispatch, obj),
    fullPageLoading: (obj) => fullPageLoading(dispatch, obj),
  };
};

const mapStateToProps = (state) => {
  return {
    userInfo: state.loggedUser,
    isDrawerOpen: state?.schoolAdminDashboardInformation.isDrawerOpen,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(DashboardData)
);
